

























import { Vue, Component } from "vue-property-decorator";
import ActForm from "@/components/act/ActForm.vue";
import { Act as IAct } from "@/api/models/act";
import { Contract as IContract } from "@/api/models/contract";
import { AxiosError } from "axios";
import { ErrorResponse as IErrorResponse } from "@/api/models/error-response";
import { ValidationErrorResponse as IValidationErrorResponse } from "@/api/models/validation-error-response";
import api from "@/getinfo-api";
import CBreadCrumbs from "@/components/form/CustomPage/CBreadCrumbs.vue";

@Component({
  components: { CBreadCrumbs, ActForm }
})
export default class ActEdit extends Vue {
  act!: IAct;
  companyId!: string;

  data() {
    return {
      act: undefined,
      companyId: undefined
    };
  }
  get breadcrumbs() {
    return [
      {
        to: { name: "acts" },
        label: this.$tc(this.$translate.CertificatesOfCompletedWorks)
      },
      {
        to: { name: "act", params: { actId: this.act.id } },
        label: this.act.number
      },
      {
        label: this.$tc(this.$translate.Edit)
      }
    ];
  }

  getAct() {
    api.ActApi.get(this.$route.params.actId)
      .then((res: { data: IAct }) => {
        this.act = res.data;
        document.title += ` ${this.act.number}`;

        api.ContractApi.get(this.act.contractId).then(
          (res: { data: IContract }) => {
            this.companyId = res.data.companyId;
          }
        );
      })
      .catch((error: AxiosError<IErrorResponse | IValidationErrorResponse>) => {
        if (error.response?.status === 403) {
          this.$router.push({ name: "error" });
        }
      });
  }

  created() {
    this.getAct();
  }
}
